/**
 * The unmatched-path frame (QA round 18 #137, signed-in branch): a non-route
 * path — anything nginx's SPA fallback serves as index.html but the router
 * does not handle — lands here inside the shell instead of a blank work
 * surface. The signed-out branch never reaches it: RequireAuth redirects to
 * /login before the shell mounts.
 */

import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/page-header';
import { Button } from '../components/ui/button';

export function NotFound() {
  return (
    <div>
      <PageHeader
        title="Page not found"
        desc="This address does not match any admin screen. Check the URL, or go back to the dashboard."
      />
      <Link to="/" className="block">
        <Button variant="outline" size="sm">
          Back to dashboard
        </Button>
      </Link>
    </div>
  );
}
